import React, { useEffect, useContext, useMemo, useState } from "react";
import "@/assets/css/filter.css";
import includeIcon from "@/assets/img/include.svg";
import excludeIcon from "@/assets/img/exclude.svg";
import { ReactComponent as RemoveIcon } from "@/assets/img/filter-delete.svg";
import { FilterSearch } from "@/components/filter-search/filter-search";
import styles from "@/page-components/snapshot/snapshots.module.css";
import clsx from "clsx";
import { Button } from "react-bootstrap";
import { SnapshotContext } from "@/page-components/snapshot/snap.contex";
import Tooltip from "@/components/tooltip/tooltip";
import { useTagsStatistics } from "@/services/snapshots/getTagsKeys.repo";
import { useTagValueStatistics } from "@/services/snapshots/getTagValue.repo";
import { useNavigate } from "react-router-dom";

/**
 * @typedef {import('@/services/snapshots/getAzureFilter.repo').GetAllStatisticsFilters} Tag
 */

/**
 * @typedef TagItemProps
 * @property {Tag} tag
 * @property {string} service
 * @property {number} index
 */

/**
 * @param {TagItemProps} props
 */

const TagItem = ({ tag, service, index }) => {
  const context = useContext(SnapshotContext);
  const { data: dimensionValues, isLoading } = useServiceTagValues(
    service,
    tag.filterOn
  );

  const filteredValues = useMemo(() => {
    return (
      (tag.values || []).map((e) => ({
        id: e,
        name: e,
      })) || []
    );
  }, [tag.values]);

  const query = useMemo(() => {
    return {
      service,
    };
  }, [service]);

  const { data: tagsdata } = useTagsStatistics(query);
  const tagLabels = tagsdata?.data || [];
  const tagLabelsFilterOn = tagLabels.find(
    (e) => tag.filterOn?.length && e.id === tag.filterOn
  );

  const navigate = useNavigate();
  const handleTagSelection = () => {
    // Reset page to 1 when a filter is selected
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  };
  const selectedTagSnapshot = useMemo(() => {
    return context?.selectedSnapshotTags.map((e) => e.filterOn);
  }, [context?.selectedSnapshotTags]);
  const [tempSelectedValues, setTempSelectedValues] = useState(filteredValues);
  const [currentSelectedValues, setCurrentSelectedValues] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);

  const handleCancel = () => {
    setTempSelectedValues(currentSelectedValues);
  };

  const handleApply = () => {
    context?.setSelectedSnapshotTags((arr) => {
      const newArr = [...arr];
      newArr[index].values = tempSelectedValues.map((e) => e.id);
      return newArr;
    });
    setCurrentSelectedValues(tempSelectedValues);
  };

  useEffect(() => {
    setTempSelectedValues(filteredValues);
    setCurrentSelectedValues(filteredValues);
  }, [filteredValues]);

  const handleDropdownClose = () => {
    setApplyTrue(true);
    document.body.click();
  };

  return (
    <div className={styles.filter_select_box}>
      <div className={styles.service_name_box}>
        <div className={styles.services_name_css}>
          <div className="w-100">
            <FilterSearch
              // options={tagLabels}
              options={tagLabels.filter(
                (tagLabel) => !selectedTagSnapshot.includes(tagLabel.id)
              )}
              displayValue="name"
              selectedValues={[tag.filterOn]}
              searchFieldPlaceholder={"Filter Tags"}
              onSelect={(selectedItem) => {
                context.setSelectedSnapshotTags((arr) => {
                  const newArr = [...arr];
                  newArr[index].filterOn = selectedItem.id;
                  newArr[index].values = [];
                  return newArr;
                });
              }}
              toggle={
                <div
                  className={clsx(styles.filter_dimension_toggle, {
                    [styles.filter_dimension_toggle_selected]:
                      tagLabelsFilterOn,
                  })}
                >
                  {tagLabelsFilterOn ? tagLabelsFilterOn.name : "Add Tags"}
                </div>
              }
            />
          </div>
          {tagLabelsFilterOn && (
            <Tooltip
              tooltipContent="Remove"
              overlayProps={{ placement: "bottom-end" }}
            >
              {(_show, setShow) => (
                <Button
                  variant="link"
                  onMouseEnter={() => setShow(true)}
                  onMouseLeave={() => setShow(false)}
                  className={clsx("p-0", styles.remove_icon)}
                  onClick={() => {
                    if (context?.selectedSnapshotTags.length > 1) {
                      context?.setSelectedSnapshotTags((arr) => {
                        const newArr = [...arr];
                        newArr.splice(index, 1);
                        return newArr;
                      });
                    } else {
                      context?.setSelectedSnapshotTags([
                        {
                          filterOn: "",
                          filterType: "include",
                          values: [],
                        },
                      ]);
                    }
                    handleDropdownClose();
                  }}
                >
                  <RemoveIcon />
                </Button>
              )}
            </Tooltip>
          )}
        </div>
      </div>
      <div className={styles.filter_grouping_box_inner}>
        <div className={styles.filter_group_name_css_inner}>
          <FilterSearch
            multiselect
            showApply
            applyTrue={applyTrue}
            setApplyTrue={setApplyTrue}
            inclusion={tag.filterType === "include"}
            onInclusionChange={(inclusion) => {
              context.setSelectedSnapshotTags((s) => {
                const list = [...s];
                list[index].filterType = inclusion;
                return list;
              });
            }}
            options={(dimensionValues?.data || []).map((e) => ({
              id: e?.id || "null",
              name: e.name || "null",
            }))}
            displayValue="name"
            loading={isLoading}
            // selectedValues={filteredValues}
            selectedValues={tempSelectedValues}
            searchFieldPlaceholder={"Tags " + tagLabelsFilterOn?.name || ""}
            // onSelect={(list) => {
            //   handleTagSelection();
            //   context?.setSelectedSnapshotTags((arr) => {
            //     const newArr = [...arr];
            //     newArr[index].values = list.map((e) => e.id);
            //     return newArr;
            //   });
            // }}
            // onRemove={(list) => {
            //   context?.setSelectedSnapshotTags((arr) => {
            //     const newArr = [...arr];
            //     newArr[index].values = list.map((e) => e.id);
            //     return newArr;
            //   });
            // }}
             onSelect={(list) => {
              setTempSelectedValues(list);
            }}
            onRemove={(list) => {
              setTempSelectedValues(list);
            }}
            disabled={!tag?.filterOn?.length}
            toggle={
              <div className="hstack gap-1 mt-1">
                {!tag?.filterOn?.length && (
                  <span className={styles.placeholder_text}>Choose Values</span>
                )}
                {tag?.filterOn?.length > 0 && tempSelectedValues.length === 0 && (
                  <div className={clsx(styles.chip, "w-100")}>Value</div>
                )}
                {tempSelectedValues.length >= 1 && (
                  <span className={clsx(styles.chip, "w-100 gap-2 d-flex")}>
                    <img
                      src={
                        tag.filterType === "include" ? includeIcon : excludeIcon
                      }
                      alt=""
                    />
                    <span
                      className={styles.chip_text}
                      style={{ minWidth: "0" }}
                    >
                      <span className="text-truncate w-100 d-block">
                        {tempSelectedValues
                          .slice(0, 1)
                          .map((e) => e.name || null)
                          .join(",")}
                      </span>
                    </span>
                    {tempSelectedValues.length > 1 && (
                      <span>+{tempSelectedValues.length - 1}</span>
                    )}
                  </span>
                )}
              </div>
            }
            onCancel={() => {
              handleCancel();
            }}
            onApply={() => {
              handleApply();
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 * @typedef {import('@/services/costExplorer/getDimensionValues.repo').AWS_TAGS} AWS_TAGS
 */

/**
 * @typedef {import('@/services/costExplorer/getDimensionValues.repo').AZURE_TAGS} AZURE_TAGS
 */

/**
 *
 * @param {'aws' | 'azure' | 'gcp'} selectedService
 * @param {'aws' | 'azure' | 'gcp'} service
 * @param {AWS_TAGS | AZURE_TAGS} columnName
 * @returns
 */
const useServiceTagValues = (service, columnName) => {
  const {
    data: values,
    refetch: fetchValues,
    isLoading,
  } = useTagValueStatistics({
    columnName,
    service,
  });
  useEffect(() => {
    if (service && columnName) {
      fetchValues();
    }
  }, [columnName, fetchValues, service]);
  return { data: values || [], isLoading };
};

export default TagItem;
